// @ts-nocheck
import React, { useState } from 'react';
import DisabledReasonsList from './components/DisabledReasonsList';
import ActionBar from '../../layout/ActionBar';
import EditDisabledReason from './slideout/EditDisabledReason';
import SlidingPane from 'react-sliding-pane';
import Button from '../../common/Button';
import { useTranslation } from 'react-i18next';
import { usePageTitle } from '../../../util/pageTitle';

function DisabledReasons() {
  const { t } = useTranslation();
  usePageTitle(['Disabled reasons', 'Settings']);
  const [reload, setReload] = useState<Date | undefined>();
  const [addDisableReasonSlideoutOpen, setAddDisableReasonSlideoutOpen] =
    useState(false);

  return (
    <>
      <ActionBar>
        <Button
          className="btn btn-primary"
          onClick={() => setAddDisableReasonSlideoutOpen(true)}
          text={t('Add disabled reason')}
          testId="add-disabled-reason-button"
        />
      </ActionBar>

      <DisabledReasonsList reload={reload} />

      <SlidingPane
        isOpen={addDisableReasonSlideoutOpen}
        hideHeader={true}
        from="right"
        className="side-panel"
        onRequestClose={() => setAddDisableReasonSlideoutOpen(false)}
      >
        <EditDisabledReason
          done={(d) => {
            setReload(new Date());
            setAddDisableReasonSlideoutOpen(false);
          }}
          cancel={() => setAddDisableReasonSlideoutOpen(false)}
        />
      </SlidingPane>
    </>
  );
}

export default DisabledReasons;
